<span class="material-icons" [class.icon-none]="icon === '—'" [class.check]="icon === 'check'">{{icon}}</span>
<span *ngIf="!this.icon">
    <ng-container *ngIf="isAmount; else notAmount" >
        {{ value | separator }} {{ 'OFFER_SECTION.SHARED.currencyShortcut' | translate }}
    </ng-container>
    <ng-template #notAmount>
        {{ value | translate }}
    </ng-template>
</span>
<div *ngIf="showRecommendation" class="coverage-variant-recommendation">
    <div class="coverage-variant-recommendation__label">{{ 'OFFER_SECTION.SHARED.recommended' | translate }}</div>
    <img class="coverage-variant-recommendation__image"
         [src]="highlightedImageSrc">
</div>

